
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 28 28"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"nonzero"}},[_c('path',{attrs:{"fill":"#1A68EC","d":"M13 4h6a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3h-6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3z"}}),_c('path',{attrs:{"fill":"#0F367A","d":"M9 7v14a4 4 0 0 0 4 4h6a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4h-6a4 4 0 0 0-3.995 3.8L9 7zm2 0l.005-.15A2 2 0 0 1 13 5h6a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-6a2 2 0 0 1-2-2V7z"}}),_c('path',{attrs:{"fill":"#0F367A","d":"M5.828 9.293a1 1 0 0 1 1.415 1.414l-1.795 1.794 7.556.035a1 1 0 0 1 .99.887l.006.117a1 1 0 0 1-1.004.996L5.38 14.5l1.863 1.863a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.415 0l-4.242-4.242z"}})])])
          )
        }
      }
    